<template>
  <div class="wrapper">
    <div class="title">Calls in the last {{ this.hours }} hour(s) - {{ this.total }}</div>
    <div class="chart" id="LastHourOutcomePie"></div>
  </div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
import am4themes_material from "@amcharts/amcharts4/themes/material";
export default {
  components: {},
  props: {
    stats: {
      type: Object,
      required: true,
    },
    customers: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: "pie",
    },
    hours: {
      type: Number,
      default: 1,
    },
  },
  data: function () {
    return {
      total: 0,
    };
  },
  methods: {
    GenerateChart(hoursAgo, ID, pieTitle = null, debug = false) {
      am4core.useTheme(am4themes_material);
      let chart = null;
      if (this.type == "pie") {
        chart = am4core.create(ID, am4charts.PieChart);
      } else {
        chart = am4core.create(ID, am4charts.XYChart);
      }

      let hours = Object.keys(this.stats);
      hours = hours.sort(function (a, b) {
        return new Date(b) - new Date(a);
      });

      var XhoursBefore = new Date(new Date().getTime() - hoursAgo * 60 * 60 * 1000);

      if (debug) console.log(XhoursBefore);

      const daysToCompile = {};

      for (const [time, customerData] of Object.entries(this.stats)) {
        const date = new Date(time);

        if (XhoursBefore <= date) {
          daysToCompile[time] = customerData;
          if (debug) console.log(date);
        }
      }

      const outcomeData = {};
      for (const [time, customersArr] of Object.entries(daysToCompile)) {
        for (const [customerId, customerData] of Object.entries(customersArr)) {
          const customerName = this.customers[customerId].customer_name;
          for (const [outcome, count] of Object.entries(customerData)) {
            if (outcomeData[customerName]) {
              outcomeData[customerName] += count;
            } else {
              outcomeData[customerName] = count;
            }
            this.total += count;
          }
        }
      }

      const chartData = [];

      for (const [customerName, count] of Object.entries(outcomeData)) {
        const obj = {
          Customer: customerName,
          Count: count,
        };
        chartData.push(obj);
      }

      chart.data = chartData;

      // Add and configure Series
      if (this.type == "pie") {
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "Count";
        pieSeries.dataFields.category = "Customer";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 0;
        chart.numberFormatter.numberFormat = "#.#";
        pieSeries.labels.template.text = "{category}: {value.percent}% ({value.value})";
        pieSeries.labels.template.disabled = true;

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;
      } else {
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Customer";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = 300;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        var barSeries = chart.series.push(new am4charts.ColumnSeries());
        barSeries.dataFields.valueY = "Count";
        barSeries.dataFields.categoryX = "Customer";
        barSeries.name = "Customer";
        barSeries.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        barSeries.columns.template.fillOpacity = 0.8;

        var columnTemplate = barSeries.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;
      }

      chart.hiddenState.properties.radius = am4core.percent(0);
    },
  },
  mounted() {
    this.GenerateChart(this.hours, "LastHourOutcomePie");
  },
};
</script>

<style scoped>
.wrapper {
  height: inherit;
  width: inherit;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 15fr;
  height: 400px;
}
.chart {
  height: 100%;
}
.title {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
}
</style>
